var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ejs-grid',{ref:"listNe",attrs:{"dataSource":_vm.data}},[_c('e-columns',[_c('e-column',{attrs:{"field":"text","headerText":_vm.$t("Software.td_neID"),"width":"15%","clipMode":"EllipsisWithTooltip"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }